import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
// import AntDTable from '../../Components/Table/AntDTable';
import toast from 'react-hot-toast';
import BtnExcel from '../../Components/BtnExcel';
import dayjs from 'dayjs';
import { capitalizeText, formatAmount, getEndDate, getPropertyId, getStartDate, getStatus, getTodayDateISO } from '../../Utils/Common';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Form,
    Input,
    DatePicker,
    Table,
    Tag,
    Select,
    Upload,
} from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  DoubleArrow,
} from '@mui/icons-material';
import { ExclamationCircleFilled, InboxOutlined, ProductOutlined } from '@ant-design/icons';
import { MoreVert } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { formatDate } from '../../Utils/Common';
import TextArea from 'antd/es/input/TextArea';

const { RangePicker } = DatePicker;
const { Item } = Form;
const { Search } = Input;
const { Option } = Select;
const { confirm } = Modal;

const Tenant = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const asynch_status = getStatus();
  const asynch_id = getPropertyId();
  const asynch_start = getStartDate();
  const asynch_end = getEndDate();
  
  const [preTerminate, setPreTerminate] = useState(false);
  const [movedOut, setMoveOut] = useState(false);
  const [terminateId, setTerminateId] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [attachmentsData, setAttachmentsData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [pageSize, setPageSize] = useState('');
  const [tenantData, setTenantData] = useState([]);

  const [filterConfig, setFilterConfig] = useState({
    rental_unit_id: '',
    trade_name_search: '',
    with_details: '',
    tenant_status: '',
    page: 1,
    property_id: asynch_id || '',
    start_date: asynch_start || '',
    end_date: asynch_end || '',
    status: location?.state? location.state : asynch_status ? asynch_status : '',
  });

  const [preTerminateForm] = Form.useForm();
  const [moveOutForm] = Form.useForm();
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;
  const { callPost, loading } = usePostRequest(()=>{
    fetchTenantData()
    setMoveOut(false)
    setPreTerminate(false)
    // refreshPage()
  });

  const antColorTag = (status) => {
    
      let color = 'red';

      if(status === "terminated"){
          color = 'red'
      } 
      else if(status === "active"){
        color = 'green'
      } 
      else if(status === "pre-terminated"){
        color = 'orange'
      } 
      else if(status === "for renewal"){
        color = 'blue'
      }
      else if(status === "moved out"){
        color = 'black'
      }
      else if(status === "renewed"){
        color = 'maroon'
      }
      else if(status === "upcoming"){
        color = 'purple'
      }

      return (
        <Tag color={color}>{status.toUpperCase()}</Tag>
      );
  };

  const columns = [
    {
      title: 'Contact Number',
      dataIndex: 'contact_no',
      key: 'contact_no',
    },
    {
      title: 'Tenant Info',
      dataIndex: 'tin',
      key: 'tin',
      render: (_, record) => (
        <>
          <div>Renter Name: <strong>{record.trade_name}</strong></div>
          <div>Email: <strong>{record.renter_email}</strong></div>
          <div>Tin: <strong>{record.tin}</strong></div>
          <div>Contract Date: <strong>{record.contract_date_range}</strong></div>
          <div>Lease Terms: <strong>{record.lease_term} ({record.lease_type})</strong></div>
          <div>Status:{" "} 
            {
              record.status === "terminated" ? (
               <>
                <strong>{antColorTag(record.status)}</strong>
                <strong className='tenants-terminated'> last {formatDate(record.contract_end_date)}</strong>
               </>
              ) : 
              record.status === "pre_terminated" ? (
               <>
                <strong>{antColorTag(record.status)}</strong>
                <strong className='tenants-terminated'> last {formatDate(record.preterminate_date)}</strong>
               </>
              ) : (
                <strong>{antColorTag(record.status)}</strong>
              )
            }
          </div>
        </>
      ),
    },
    {
      title: 'Payables',
      dataIndex: 'business',
      key: 'business_info',
      render: (_, record) => (
        <>
          {record.space_rate_final && (
            <div>
              Space Rental: <strong>{record.space_rate_final}</strong>
            </div>
          )}
          {record.cusa_rate_final && record.cusa_rate_final !== '0.00' && (
            <div>
              Cusa Rental: <strong>{record.cusa_rate_final}</strong>
            </div>
          )}
          {record.alfresco_rate_final && record.alfresco_rate_final !== '0.00' && (
            <div>
              Alfresco Rental: <strong>{record.alfresco_rate_final}</strong>
            </div>
          )}
          {record.payables && (
            <div>
              <div>Payables:</div>
              {record.payables.map((data, index) => (
                <div className='ps-4' key={index}>
                  <strong>{data.description}</strong>
                </div>
              ))}
            </div>
          )}
        </>
      ),
    },
    {
      title: 'Property/Building',
      dataIndex: 'property_name',
      key: 'property_name',
    },
    {
      title: 'Unit Number',
      dataIndex: 'rental_unit_name',
      key: 'rental_unit',
    },
    {
      // title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record) => (
        <ActionBtn row={record} />
      ),
    },
  ];

  function ActionBtn(row) {
    if (row.row.status !== "moved out") {
      const items = [
        {
          label: (
            <div onClick={() => navigate('/tenant/edit/' + row.row.id)}>
              View Info
            </div>
          ),
          key: 'view_info',
        },
        {
          label: (
            <div onClick={() => navigate('/tenant/rate/' + row.row.id)}>
              View Rate
            </div>
          ),
          key: 'tenant_rate',
        },
        {
          label: (
            <div onClick={() => navigate('/tenant/history/' + row.row.id)}>
              View History
            </div>
          ),
          key: 'tenant_history',
        },
        (row.row.status !== "pre-terminated") && {
          label: (
            <div onClick={() => showPreTerminate(row.row.id)}>
              Early Move Out
            </div>
          ),
          key: 'pre_terminate',
        },
        {
          label: (
            <div onClick={() => navigate('/tenant/print-soa/move-in/' + row.row.id)}>
              Print Debit SOA
            </div>
          ),
          key: 'print_debit',
        },
        (row.row.status === "terminated" || row.row.status === "for renewal") && {
          label: (
            <div
              onClick={() => navigate('/tenant/renew/' + row.row.id)}
              style={{ color: 'blue' }}
            >
              Renewal
            </div>
          ),
          key: 'renewal',
        },
        (row.row.status === "terminated" || row.row.status === "pre-terminated") && {
          label: (
            <div
              onClick={() => showMoveOut(row.row.id)}
              style={{ color: 'red' }}
            >
              Move Out
            </div>
          ),
          key: 'move out',
        },
        {
          label: (
            <div style={{ color: 'red' }} onClick={() => showDeleteConfirm(row.row.id)}>
              Delete
            </div>
          ),
          key: 'delete',
        },
      ].filter(item => item); // Remove undefined items
  
      return (
        <>
          <span className='center'>
            <Dropdown
              menu={{
                items,
              }}
              trigger={['click']}
              onClick={(e) => e.preventDefault()}
            >
              <div type='primary' className='action-btn'>
                <Space>
                  <MoreVert />
                </Space>
              </div>
            </Dropdown>
          </span>
        </>
      );
    } else {
      return (
        <>
          <span className='center'>
            <Button onClick={() => navigate('/tenant/move-out/' + row.row.id)}>
              <div type='primary' className='action-btn'>
                <Space>
                  <DoubleArrow />
                </Space>
              </div>
            </Button>
          </span>
        </>
      );
    }
  }
  
  async function fetchTenantData  () {
    setIsLoading(true)
    const response = await UseGetRequest("tenants/get", filterConfig);
    if (response?.data) {
     
      const tenant_data = response?.data?.data?.map((data) => ({
        id: data.id,
        renter_id: data.renter_id,
        trade_name: data.trade_name,
        rental_unit_id: data.rental_unit_id,
        property_id: data.property_id,
        tin: data.tin,
        business_name: data.business_name,
        contact_no: data.contact_no,
        business_nature: data.business_nature,
        start_date: data.start_date,
        lease_term: data.lease_term,
        contract_sign_date: data.contract_sign_date,
        contract_end_date: data.contract_end_date,
        contract_date_range: (formatDate(data.contract_sign_date) + " - " + formatDate(data.contract_end_date)),
        space_rental_rate: data.space_rental_rate,
        alfresco_rental_rate: data.alfresco_rental_rate,
        cusa_rental_rate: data.cusa_rental_rate,
        elec_consumption: data.elec_consumption,
        ...(data.space_rate_final && {space_rate_final: formatAmount(data.space_rate_final)}),
        ...(data.alfresco_rate_final && {alfresco_rate_final: formatAmount(data.alfresco_rate_final)}),
        ...(data.cusa_rate_final && {cusa_rate_final: formatAmount(data.cusa_rate_final)}),
        water_consumption: data.water_consumption,
        gas_consumption: data.gas_consumption,
        require_or: data.require_or,
        preterminate_date: data.preterminate_date,
        renter_email: data.renter_email,
        business_address: data.business_address,
        remarks: data.business_address,
        move_out: data.move_out,
        lease_type: data.lease_type,
        move_out_date: data.move_out_date,
        renewed_on: data.renewed_on,
        status: data.status,
        rental_unit_name: data.rental_unit_name,
        property_name: data.property_name,
        added_by: data.added_by,
        added_on: data.added_on,
        updated_by: data.updated_by,
        updated_on: data.updated_on,
        payables: data.payables,
      }))
      setTenantData(tenant_data);
      setPageSize(response?.data?.size)
    } else {
      setTenantData([])
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true)
    const response = await UseGetRequest("tenants/get", 
      {
        rental_unit_id: filterConfig.rental_unit_id,
        trade_name_search: filterConfig.trade_name_search,
        with_details: filterConfig.with_details,
        status: filterConfig.status,
      }
    );
    if (response?.data) {
      const excel_data = response?.data?.data?.map((data) => ({
        id: data.id,
        trade_name: data.trade_name && capitalizeText(data.trade_name),
        tin: data.tin,
        business_name: data.business_name,
        business_nature: data.business_nature,
        business_address: data.business_address,
        start_date: data.start_date,
        lease_type: data.lease_type,
        lease_term: data.lease_term,
        contract_sign_date: data.contract_sign_date && formatDate(data.contract_sign_date),
        contract_end_date: data.contract_end_date && formatDate(data.contract_end_date),
        space_rental_rate: data.space_rental_rate && formatAmount(data.space_rental_rate),
        alfresco_rental_rate: data.alfresco_rental_rate && formatAmount(data.alfresco_rental_rate),
        cusa_rental_rate: data.cusa_rental_rate && formatAmount(data.cusa_rental_rate),
        space_rate_final: data.space_rate_final,
        alfresco_rate_final: data.alfresco_rate_final,
        cusa_rate_final: data.cusa_rate_final,
        elec_consumption: data.elec_consumption,
        water_consumption: data.water_consumption,
        gas_consumption: data.gas_consumption,
        require_or: data.require_or,
        preterminate_date: data.preterminate_date && formatDate(data.preterminate_date),
        renter_email: data.renter_email,
        contact_no: data.contact_no,
        remarks: data.remarks,
        move_out: data.move_out,
        move_out_date: data.move_out_date && formatDate( data.move_out_date),
        renewed_on: data.renewed_on && formatDate(data.renewed_on),
        status: data.status,
        rental_unit_name: data.rental_unit_name,
        property_name: data.property_name && capitalizeText(data.property_name),
        added_on: data.added_on,
        updated_on: data.updated_on,

      }))
      setExcelData(excel_data)
      setExportLoading(false)
    } else {
      setExcelData([])
      setExportLoading(false)
    }
  }


  async function fetchPropertyData() {

    const response = await UseGetRequest("properties/get", {property_id: '', tenant_status: filterConfig.tenant_status});
    if (response?.data) {
      setPropertyData(response?.data?.data);
    } else {
      setPropertyData([])
    }

}

  const handleOkPreTerminate = () => {
    preTerminateForm.validateFields().then(values => {
      const preTerminateData = {
        tenant_id: terminateId,
        remarks: values.remarks,
        preterminate_date: values.preterminate_date.format("YYYY-MM-DD")
      }
      callPost(
        "tenants/update_preterminate_date", 
        preTerminateData,
        false,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleOkMoveOut = () => {
    moveOutForm.validateFields().then(values => {
      const resetData = {
        tenant_id: terminateId,
        move_out_date: values.move_out_date.format("YYYY-MM-DD"),
        move_out_remarks: values.move_out_remarks,
      }

      const file = attachmentsData.map((data) => {
        if(data.originFileObj){
          return data.originFileObj;
        }
        // const convert_file = new File(data)
        return data
      });

      var finalValues = Object.entries({...resetData, attachments: file }).map(([key, value]) => ({
        key,
        value,
      }));

      callPost(
        "tenants/move_out", 
        finalValues,
        true,
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showPreTerminate = (id) => {
    setPreTerminate(true);
    setTerminateId(id);
  };
  
  const handlePreTerminateCancel = () => {
    setPreTerminate(false);
    setTerminateId('')
  };

  const showMoveOut = (id) => {
    setMoveOut(true);
    setTerminateId(id);
  };

  const handleMoveOutCancel = () => {
    setMoveOut(false);
    setTerminateId('')
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this tenant?',
      icon: <ExclamationCircleFilled style={{ color: 'red' }}/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "tenants/delete", 
          {tenant_id: id},
          false
        );
      },
    });
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };
  
  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const onSearchType = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        status: e || '',
        tenant_status: e, 
        page: 1,
      }
    ));
    if(e){
      localStorage.setItem('status', JSON.stringify(e));
    } else {
      localStorage.removeItem('status');
    }
  }; 

  const onSearchProperty = (e) => {
    setFilterConfig((prev) => (
      { 
        ...prev,
        property_id: e || '',
        page: 1,
      }
    ));
    if(e){
      localStorage.setItem('property_id', JSON.stringify(e));

    } else {
      localStorage.removeItem('property_id');
    }
  }; 

  const onSearchDate = (e) => {
    if(e){
     setFilterConfig((prev) => (
       {
         ...prev,
         start_date: e[0].format("YYYY-MM-DD"),
         end_date: e[1].format("YYYY-MM-DD"),
         page: 1,
       }
     ));
     localStorage.setItem('start_date', JSON.stringify(e[0].format("YYYY-MM-DD")));
     localStorage.setItem('end_date', JSON.stringify(e[1].format("YYYY-MM-DD")));
    } else {
      setFilterConfig((prev) => (
        {
          ...prev,
          start_date: '',
          end_date: '',
          page: 1,
        }
      ));
      localStorage.removeItem('start_date');
      localStorage.removeItem('end_date');
    }
  };

  const normFile = (e) => {

    if (Array.isArray(e)) {
        setAttachmentsData(e)
    }
    setAttachmentsData(e?.fileList)
    
  };
  
  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  const pageSizeOptions = ['10', '20', '50', '100', `${pageSize}`];
  const sortedPageSizeOptions = pageSizeOptions.filter(item => item <= pageSize).sort((a, b) => Number(a) - Number(b));

  useEffect(() => {
    fetchTenantData();
    fetchExportData()
    fetchPropertyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
      <Layout className='page'>
        <Navbar navKey={'tenant_nav'}/>
        <Layout className='content-container overflow-tenant'>
          <Row className='custom-padding responsive-inline responsive-tab-inline'>
            <Col span={9} className='header-container'>
                TENANT
            </Col>
            <Col span={15} className='mt-2 responsive-tab-width' align='end'>
              <Space className='responsive-inline'>
                <BtnExcel
                  label={"Export to Excel"}
                  size={"sm"}
                  excelData={excelData}
                  xlsxHeaders={[
                    "ID",
                    "Trade Name",
                    "Tin",
                    "Business Name",
                    "Business Nature",
                    "Business Address",
                    "Start Date",
                    "Lease Type",
                    "Lease Term",
                    "Contract Start Date",
                    "Contract End Date",
                    "Space Rental Rate",
                    "Alfresco Rental Rate",
                    "Cusa Rental Rate",
                    "Space Rental",
                    "Alfresco Rental",
                    "Cusa Rental",
                    "Electric Consumption",
                    "Water Consumption",
                    "Gas Consumption",
                    "Is Required OR",
                    "Preterminated Date",
                    "Renter Email",
                    "Contact Number",
                    "Remarks",
                    "Move Out",
                    "Move Out Date",
                    "Renewed On",
                    "Status",
                    "Rental Unit Name",
                    "Property Name",
                    "Added On",
                    "Updated On",
                  ]}
                  handleData={fetchExportData}
                  isClicked={exportLoading}
                  fileName={`Tenant_${getTodayDateISO()}.xlsx`}
                />
                <Button 
                  className='button-color responsive-header-btn' 
                  onClick={() => navigate('/tenant/add')} 
                  type="primary"
                >
                  + Add Tenant
                </Button>
              </Space>
            </Col>
          </Row>
          <Row>
            <Space className='responsive-inline excel-row'>
              <Search
                placeholder="Search..."
                size='medium'
                onSearch={(e)=>handleSearchChange(e)}
                onChange={(e)=>handleEmpty(e)}
                className='responsive-header-input'
              /> 
              <RangePicker 
                renderExtraFooter={() => 'extra footer'} 
                className='responsive-header-input'
                value={[
                  filterConfig?.start_date ? dayjs(filterConfig.start_date) : null,
                  filterConfig?.end_date ? dayjs(filterConfig.end_date) : null
                ]}
                onChange={(e)=>onSearchDate(e)}
              />
              <Select
                placeholder="All Status"
                onChange={(e)=>onSearchType(e)}
                placement='bottomLeft'
                value={filterConfig.status}
                // style={{width:'14vw'}}
                className='select-field responsive-header-input'
                align='left'
                options={[
                  {
                    value: '',
                    label: 'All Status',
                  },
                  {
                    value: 'active',
                    label: 'Active',
                  },
                  {
                    value: 'renewal',
                    label: 'For Renewal',
                  },
                  {
                    value: 'renewed',
                    label: 'Renewed',
                  },
                  {
                    value: 'terminated',
                    label: 'Terminated',
                  },
                  {
                    value: 'pre_terminated',
                    label: 'Pre-Terminated',
                  },
                  {
                    value: 'upcoming',
                    label: 'Upcoming',
                  },
                  {
                    value: 'move_out',
                    label: 'Move Out',
                  },
                ]}
              />     
              <Select 
                  placeholder="Select a property" 
                  onChange={(e) => onSearchProperty(e)}
                  showSearch
                  value={filterConfig.property_id}
                  className='select-field responsive-header-input'
                  filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
              >
                <Option key='all' value=''>All Property</Option>
                {propertyData.map((option) => (
                    <Option key={option.id} value={option.id}>{option.name}</Option>
                ))}
              </Select>
            </Space>
          </Row>
          <Row className='page-content mb-5'>
            <Col span={24} className='responsive-overflow-auto'>
              <Table 
                columns={columns} 
                dataSource={tenantData} 
                loading={{
                  indicator: customSpinner, // Use custom spinner
                  spinning: isLoading, // Set spinning based on loading state
                }}
                pagination={{
                  defaultPageSize: 10,
                  pageSizeOptions: sortedPageSizeOptions,
                  // showQuickJumper: true,
                  showSizeChanger: true,
                  total: pageSize,
                  current: filterConfig?.page,
                  pageSize: filterConfig?.total_records_per_page,
                }}
                onChange={handleTableChange}
              />
            </Col>
          </Row>
        </Layout>
        <Modal
          title="Early Move Out Tenant"
          open={preTerminate}
          confirmLoading={loading}
          onOk={handleOkPreTerminate}
          onCancel={handlePreTerminateCancel}
          okText="Submit"
        >
          <Form form={preTerminateForm} layout='vertical' className='mt-4'>
            <Item 
              name="preterminate_date" 
              label="Choose early move out date"
              rules={[{ required: true, message: 'Please enter your Pre Terminate Date!' }]}
            >
              <DatePicker className='date-picker' style={{width:'100%'}}/>
            </Item>
            <Item 
              name="remarks" 
              label="Remarks"
            >
              <TextArea/>
            </Item>

          </Form>

        </Modal>
        <Modal
          title="Move Out Tenant"
          open={movedOut}
          confirmLoading={loading}
          onOk={handleOkMoveOut}
          onCancel={handleMoveOutCancel}
          okText="Submit"
        >
          <Form form={moveOutForm} layout='vertical' className='mt-4'>
            <Item 
              name="move_out_date" 
              label="Choose Move Out date"
              rules={[{ required: true, message: 'Please enter your Pre Terminate Date!' }]}
            >
              <DatePicker className='date-picker' style={{width:'100%'}}/>
            </Item>
            <Item 
              name="move_out_remarks" 
              label="Remarks"
              rules={[{ required: true, message: 'Please enter your Remarks!' }]}

            >
              <TextArea/>
            </Item>
            <Item
              label="Attachment"
             >
              <Item name="attachments" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
                <Upload.Dragger name="files" action="/upload.do">
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click or drag file to this area to upload</p>
                <p className="ant-upload-hint">Support for a single or bulk upload.</p>
                </Upload.Dragger>
              </Item>
            </Item>

          </Form>

        </Modal>
      </Layout>
  )
}

export default Tenant
